import { intersection, pathOr } from 'rambda'

export const getComponentSizeClasses = (() => {
  const sizes = ['xs', 'sm', 'md', 'lg', 'xl']
  const getComponentClasses = pathOr('', ['$vnode', 'data', 'staticClass'])

  return (vm) => {
    const classes = getComponentClasses(vm)

    return intersection(sizes, classes.split(' '))
  }
})()
